/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import SampleCheck from '../assets/sample-check.png';
import { memo } from 'react';
import Styles from '../css/AutopayPage.module.css';
import AutopayForm from '../components/forms/AutopayForm';
import { AutopayProvider } from '../contexts/AutopayContext';
import { useRootContext } from '../contexts/RootContext';
import { useViewingContext } from '../contexts/ViewingContext';

const AutopayPage = () => {
  const { isServicerView } = useViewingContext();

  const rootContext = useRootContext();

  return (
    <AutopayProvider>
      <div className={Styles.page}>
        <AutopayForm />
        {!isServicerView && (
          <div ref={rootContext.scrollRef} className={Styles.sampleCheck}>
            <h2 className={`${Styles.checkLabel}`}>Sample Check</h2>
            <img src={SampleCheck} alt='Sample Check' className={`${Styles.checkImage}`} />
          </div>
        )}
      </div>
    </AutopayProvider>
  );
};

export default memo(AutopayPage);
